<app-breadcrumb [pathList]="pathList"></app-breadcrumb>
<div [ngBusy]="{busy: busy, message: 'Loading...', backdrop: false, delay: 0, minDuration: 600}"></div>
<div class="container-fluid">
    <app-single-club (pathListEvent)="loga($event)" [id]="id" [single]="single" [componentService]="realClubService" [routePart]="'real_club'"></app-single-club>
    <app-alertbox #alertbox1 [alerts]=""></app-alertbox>
</div>